module.exports = __webpack_public_path__ + "static/media/flag-empty.fa6567a3.png";